<template>
  <div class="content-box">
    <div v-html="content">

    </div>
    <div v-if="content" class="btn-box ql-align-center">
      <el-button class="next-btn" type="warning" round @click="back">返回 Back</el-button>
    </div>
  </div>
</template>

<script>
  import {
    getContent
  } from "@/assets/js/api.js";
  export default {
    watch: {
      '$route'(to, from) {
        if (to.path.indexOf('content') != -1) {
          const code = to.params.code
          this.getContentData(code)
        }

        console.log(to)
      }
    },
    created() {
      const code = this.$route.params && this.$route.params.code;
      this.getContentData(code)
    },

    data() {
      return {
        content: ''
      }
    },
    methods: {
      back() {
        this.$router.push('/')
      },
      getContentData(code) {
        getContent(code).then(res => {
          this.content = res.context;
        });
      }
    }
  }

</script>

<style>
  .content-box {
    padding: 20px;
    /* border: 1px solid #ccc; */
    border-radius: 5px;
    margin-bottom: 20px;
    max-width: 1200px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/view/common/contentView.vue